export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/h264parser.worker.ac847271.worker.js");
}
